import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { keyBy } from 'lodash';

import './index.scss';
import CommonTable from '../../../../common/table';
import {
  REDUCER_NAME,
  fetchMostRecent,
  resetStoreData,
} from '../../../../reducer';
import Const from '../../../../Const';
import { getDataFollowKeyByDot } from '../../../../../helpers/Common';

class MostRecent extends React.Component {
  componentDidMount() {
    const { fetchMostRecent, resetStoreData } = this.props;
    resetStoreData('mostRecentData');
    fetchMostRecent();
  }

  componentDidUpdate(prevProps) {
    const { fetchMostRecent, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('mostRecentData');
      fetchMostRecent();
    }
  }

  transformData = (data, filterCondition) => {
    if (Object.keys(filterCondition).length) {
      const filteredData = data.filter(function(item) {
        for (var key in filterCondition) {
          if (item[key] === undefined || item[key] !== filterCondition[key])
            return false;
        }
        return true;
      });

      return filteredData;
    }
    return data;
  };

  render() {
    const {
      mostRecentData: { data, isLoading, filterCondition },
      mostRecentData,
    } = this.props;

    const filteredData = this.transformData(data, filterCondition);

    return (
      <CommonTable
        isOnlyShowDate={true}
        dateTitleFormat="MMMM YYYY"
        listColumn={Const.MostRecentTable}
        ids={filteredData.map(item =>
          getDataFollowKeyByDot(item, Const.MostRecentTable.ID),
        )}
        list={keyBy(filteredData, Const.MostRecentTable.ID)}
        isLoading={isLoading}
        dateKey="publicDate"
        type="mr"
        commonData={mostRecentData}
        isGroupData={true}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    mostRecentData: state[REDUCER_NAME].mostRecentData,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMostRecent: () => dispatch(fetchMostRecent()),
    resetStoreData: storeName => dispatch(resetStoreData(storeName)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(MostRecent);
